import React, { useEffect } from 'react';
import LogoutContent from 'components/authentication/LogoutContent';
import AuthCardLayout from 'layouts/AuthCardLayout';

const Logout = () => {
  useEffect(() => {
    // Borra el token de localStorage
    localStorage.removeItem('authToken');
  }, []);
  return (
    <AuthCardLayout>
      <div className="text-center">
        <LogoutContent layout="card" titleTag="h3" />
      </div>
    </AuthCardLayout>
  );
};

export default Logout;
